<template>
  <div>
    <div class="m-b-24">
      <el-button type="primary" size="small" @click="sendClick" v-if="this.$hasPerm('B002&1')">手动发送</el-button>
      &nbsp;&nbsp;&nbsp;
      <el-dropdown v-if="this.$hasPerm('B002&2')" @command="visable">
        <el-button plain size="small">
          导出 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="exportEmail">导出至邮箱</el-dropdown-item>
          <el-dropdown-item command="exportExcel">导出至Excel</el-dropdown-item>
          <el-dropdown-item command="exportProperty" v-if="this.$hasPerm('B008')">导出至日蚀</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      &nbsp;&nbsp;&nbsp;
      <el-dropdown v-if="this.$hasPerm('B006')" @command="visable">
        <el-button plain size="small">
          批量更新 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="caseStatus">更新案件状态</el-dropdown-item>
          <el-dropdown-item command="updatePlan">更新作业方案</el-dropdown-item>
          <el-dropdown-item command="pauseUrge">暂停作业</el-dropdown-item>
          <el-dropdown-item command="continueUrge">继续作业</el-dropdown-item>
          <el-dropdown-item command="updateStrategy">更新策略组</el-dropdown-item>
          <el-dropdown-item command="updateLabel">更新本人标签</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      &nbsp;&nbsp;&nbsp;
      <el-dropdown v-if="this.$hasPerm('B007')" @command="visable">
        <el-button plain size="small">
          导入更新 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="importForm">更新还款及金额</el-dropdown-item>
          <el-dropdown-item command="importContactForm">添加联系人</el-dropdown-item>
          <el-dropdown-item command="importNewCase"  v-if="this.$hasPerm('B007&1')">重新入案子公司</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      &nbsp;&nbsp;&nbsp;
      <el-dropdown @command="visable" v-if="this.$hasPerm('B010')">
        <el-button plain size="small">
          录音下载 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="exportRecordFileDownload">录音文件下载</el-dropdown-item>
          <el-dropdown-item command="exportRecordTranslationDownload">录音翻译下载</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      &nbsp;&nbsp;&nbsp;
      <el-button type="primary" @click="wavToText" size="small" plain v-if="this.$hasPerm('B002&4')">录音转文本</el-button>
    </div>


    <!--弹层-->
    <div class="dialog">
      <el-dialog title="手动发送" :visible.sync="sendVisable" width="45%" center>
        <el-form label-width="150px">
          <el-form-item label="发送对象:">
            <el-checkbox-group v-model="sendReqBody.sendReq.collectSendObject">
              <el-checkbox label="benrendianhua">本人</el-checkbox>
              <el-checkbox label="zhixidianhua">直系</el-checkbox>
              <el-checkbox label="feizhixidianhua">非直系</el-checkbox>
              <!-- <el-checkbox label="repair">失联修复</el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发送类型:">
            <el-select v-model="sendReqBody.sendReq.sendType" @change="getChangeType" style="width: 100%;">
              <el-option label="短信" value="msg"/>
              <el-option label="语音" value="ivr"/>
              <!-- <el-option label="智能语音" value="ivoice"/> -->
              <el-option label="场景语音" value="svoice"/>
            </el-select>
          </el-form-item>
          <el-form-item label="发送通道:" >
            <el-select v-model="sendReqBody.sendReq.channel" style="width: 100%;">
              <el-option
                v-for="item in channelList"
                :key="item.code"
                :label="item.desc"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模版公司:" v-if="this.$partB()">
            <el-select placeholder="请选择" v-model="currentCompanyId" style="width: 100%;" @change="templateList" filterable>
              <template v-for="item in companyRes">
                <el-option :key="'companyKey'+item.id" :label="item.companyName" :value="item.id">{{item.companyName}}</el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="策略组:" v-if="this.$partA()">
            <el-select v-model="strategyGroup" style="width: 100%;" @change="strategyGroupChange">
              <el-option
                v-for="item in strategyGroupList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送模版:">
            <el-select v-model="sendReqBody.sendReq.templateId" style="width: 100%;" filterable>
              <template v-for="item in templateRes">
                <el-option :key="'templateKey'+item.id" :label="item.name" :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" v-html="item.contentShow ? item.contentShow : item.content"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="发送方式:">
            <el-select v-model="sendReqBody.sendReq.sendWay" style="width: 100%;">
              <el-option label="立即发送" value="immediately"/>
              <el-option label="定时发送" value="manual_timing"/>
            </el-select>
          </el-form-item>
          <div v-if="sendReqBody.sendReq.sendWay === 'manual_timing' ">
            <el-form-item label="请选择定时发送时间:">
              <el-date-picker v-model="sendReqBody.sendReq.manualTiming" type="datetime" placeholder="SEND TIME" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"/>
            </el-form-item>
          </div>
          <!-- <el-form-item label="发送比例(%):">
            <el-input-number v-model="sendReqBody.sendReq.sendRate" :min="1" :max="100" style="width: 100%;"></el-input-number>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="send" size="small" :loading="buttonLoading">确认发送</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量更新案件状态" :visible.sync="caseStatusVisable" width="45%" center>
        <el-form label-width="160px">
          <el-form-item label="案件状态:">
            <el-select v-model="caseStatusReqBody.caseStatus" collapse-tags placeholder="请选择" style="width: 90%;">
              <el-option v-for="item in caseStatusList" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item.modelName"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateCaseStatus" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog title="作业设置" :visible.sync="updatePlanVisable" width="40%" center>
        <el-form label-width="150px">
          <el-form-item label="作业设置:">
            <el-radio-group v-model="updatePlanReqBody.planType">
              <el-radio label="msg">短信</el-radio>
              <el-radio label="v&m">短信+语音</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="作业天数:">
            <el-input-number v-model="updatePlanReqBody.planDays" controls-position="right" :min="1" :max="30" label="最大为30天"></el-input-number> 天
          </el-form-item>
          <el-form-item label="最高减免:">
            <el-input-number v-model="updatePlanReqBody.planDiscount" controls-position="right" :min="0" :max="100" label="最大为100"></el-input-number> %
          </el-form-item>
          <el-form-item label="作业对象:">
            <el-checkbox-group v-model="updatePlanReqBody.collectSendObject">
              <el-checkbox label="benrendianhua" disabled>本人</el-checkbox>
              <el-checkbox label="zhixidianhua">直系</el-checkbox>
              <el-checkbox label="feizhixidianhua">非直系</el-checkbox>
              <el-checkbox label="repair">失联修复</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updatePlan" size="small">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量更新策略组" :visible.sync="updateStrategyVisible" width="40%" center>
        <el-form label-width="160px">
          <el-form-item label="策略组:">
            <el-select v-model="updateStrategyReqBody.groupId" style="width: 80%;">
              <el-option v-for="item in strategyGroupRes" :key="item.id" :label="item.groupName" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否重置作业起始日:">
            <el-switch
              v-model="updateStrategyReqBody.isReset">
            </el-switch>&#12288;
            <i class="el-icon-question" title="勾选“重置作业起始日”会以当前日期加上设置的作业天数使用新策略重新作业，如在1号开始作业，设置作业10日，若在5号更新策略时勾选，会以新策略作业至15号。"></i>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateStrategy" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量更新本人标签" :visible.sync="updateLabelVisable" width="40%" center>
        <el-form label-width="160px">
          <el-form-item label="标签:">
            <el-select v-model="updateLabelReqBody.label" style="width: 80%">
              <el-option v-for="item in labelList" :key="item.name" :label="item.name" :value="item.name"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateLabel" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog title="更新还款及金额" :visible.sync="importFormVisable" width="40%" center>
        <!-- <el-form label-width="160px">
          <el-form-item label="文件上传">
            <input type="file" @change="getFile($event)">
          </el-form-item>
        </el-form> -->
        <el-form label-width="160px">
          <el-form-item label="文件上传">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview"
              :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed"
              :file-list="fileList" :on-change="fileChanged">
              <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传模版的Excel</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" size="small"><a href="/static/template/importUpdateTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
          <el-button type="primary" @click="importUpdateUploadData($event)" size="small">提交数据</el-button>
        </div>
      </el-dialog>

      <el-dialog title="添加联系人" :visible.sync="importContactFormVisable" width="40%" center>
        <el-form label-width="160px">
          <el-form-item label="文件上传">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview"
              :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed"
              :file-list="fileList" :on-change="fileChanged">
              <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传模版的Excel</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" size="small"><a href="/static/template/importContactTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
          <el-button type="primary" @click="addContactInfo" size="small">提交数据</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="导出至日蚀系统"
        :visible.sync="exportCaseToPropertyModel"
        width="50%"
        center>
        <el-form label-width="160px">
          <el-form-item>
            <span>您正在导出{{this.count}}个案件到日蚀系统，请配置以下设置</span>
          </el-form-item>
          <el-form-item label="佣金费率:">
            <el-input v-model="zyt.commissionRateA" style="width:80%"></el-input>
          </el-form-item>
          <el-form-item label="平台服务费:">
            <el-input v-model="zyt.platformRate" style="width:80%"></el-input>
          </el-form-item>
          <el-form-item label="起委时间:">
            <el-date-picker style="width: 80%;"
                v-model="zyt.exportStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="结尾时间:">
            <el-date-picker style="width: 80%;"
                v-model="zyt.exportEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="zyt.exportNewBatch">
            </el-switch>&#12288;<span>以新批次导入 (若无勾选则当日导入多次皆视为同一批次)</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="exportCaseToPropertyModel = false" size="small">取消</el-button>
          <el-button type="primary" @click="exportCaseToZYT" size="small">确定导出</el-button>
        </div>
      </el-dialog>

      <el-dialog title="案件复制" :visible.sync="importNewCaseFormVisable" width="40%" center>
        <el-form label-width="160px">
          <el-form-item label="策略组:">
            <el-select v-model="importNewCaseBody.groupId" style="width: 100%;">
              <el-option
                v-for="item in strategyGroupList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="importNewCaseButton" size="small">提交数据</el-button>
        </div>
      </el-dialog>
    </div>
  </div>


</template>
<script>
export default {
  props: {
    caseSearchReq: {
      type: Object,
      required: true
    },
    labelList: {
      type: Array,
      required: false
    },
    caseRes: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.$partA()) {
      this.strategyGroupSearch();
    }
  },
  data() {
    return {
      sendVisable: false,
      caseStatusVisable: false,
      updatePlanVisable: false,
      updateStrategyVisible: false,
      updateLabelVisable: false,
      importFormVisable: false,
      importContactFormVisable: false,
      importNewCaseFormVisable: false,
      caseStatusList: {
        type: Array,
        required: false
      },
      // 立即发送请求报文
      sendReqBody: {
        caseSearchReq: this.caseSearchReq,
        sendReq: {
          collectSendObject: [],
          sendType: 'msg',
          templateId: null,
          sendWay: 'immediately',
          manualTiming: null,
          sendRate: 100,
          channel: null
        }
      },
      // 更新案件状态报文
      caseStatusReqBody: {
        caseStatus: null,
        caseSearchReq: this.caseSearchReq
      },
      updatePlanReqBody: {
        planType: null,
        planDays: null,
        planDiscount: null,
        collectSendObject: ['benrendianhua'],
        caseSearchReq: this.caseSearchReq
      },
      urgeStatusReqBody: {
        type: null,
        caseSearchReq: this.caseSearchReq
      },
      updateStrategyReqBody: {
        groupId: null,
        isReset: false,
        caseSearchReq: this.caseSearchReq
      },
      updateLabelReqBody: {
        label: null,
        caseSearchReq: this.caseSearchReq
      },
      companyRes: [],
      templateRes: [],
      strategyGroupRes: [],
      currentCompanyId: this.$account().companyId,
      // ------
      // 导入更新
      file: '',
      fileList: [],
      channelList: [],
      zytServerToken: null,
      exportCaseToPropertyModel: false,
      count: null,
      zyt: {
        commissionRateA: null,
        platformRate: null,
        exportStartTime: null,
        exportEndTime: null,
        exportNewBatch: false
      },
      buttonLoading: false,
      strategyGroup: null,
      strategyGroupList: [],
      importNewCaseBody: {
        caseSearchReq: this.caseSearchReq,
        groupId: null,
        companyId: null
      }
    };
  },
  methods: {
    strategyGroupSearch() {
      const self = this;
      this.$ajax({
        method: 'GET',
        url: '/robotCase/getStrategyList'
      }).then((res) => {
        const ss = [];
        res.data.forEach((group) => {
          if (group.isMain === 1) {
            this.strategyGroup = group.id;
          }
          if (group.isMain !== 2) {
            ss.push(group);
          }
        });
        self.strategyGroupList = ss;
      });
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
      });
    },
    templateList() {
      if (this.sendReqBody.sendReq.sendType === 'svoice') {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: {
            'type': this.sendReqBody.sendReq.sendType,
            'companyId': this.currentCompanyId,
            'groupId': this.strategyGroup
          }
        }).then((res) => {
          this.templateRes = res.data;
          if (res.data != null && res.data.length > 0) {
            this.sendReqBody.sendReq.templateId = res.data[0].id;
          }
        });
      } else {
        this.$ajax({
          method: 'POST',
          url: '/robotCase/getTemplateByCompanyId',
          data: {
            'type': this.sendReqBody.sendReq.sendType,
            'companyId': this.currentCompanyId,
            'groupId': this.strategyGroup
          }
        }).then((res) => {
          this.templateRes = res.data;
          if (res.data != null && res.data.length > 0) {
            this.sendReqBody.sendReq.templateId = res.data[0].id;
          }
        });
      }
    },
    sendClick() {
      if (this.$partB()) {
        this.companyList();
      }
      this.templateList();
      this.getSendChannel();
      this.sendVisable = true;
    },
    // 立即发送
    send() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        url: '/caseList/urgeCount',
        data: this.caseSearchReq
      }).then((res) => {
        loading.close();
        const initCase = res.data.initCase;
        const pauseCase = res.data.pauseCase;
        const continueCase = res.data.continueCase;
        const complateCase = res.data.complateCase;
        const pCaseCount = res.data.pCaseCount;
        const subCaseCount = res.data.subCaseCount;
        let message = '<html>';
        message += `未作业案件: ${initCase}条<br/>`;
        message += `<span style="color: red;">作业暂停案件: ${pauseCase}条</span><br/>`;
        message += `作业中案件: ${continueCase}条<br/>`;
        message += `<span style="color: red;">作业完成案件: ${complateCase}条</span><br/>`;
        message += `主案数量: ${pCaseCount}条</span><br/>`;
        message += `子案数量: ${subCaseCount}条</span><br/>`;
        message += '</html>';
        this.$confirm(message, '确认对该案件发送消息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          const h = this.$createElement;
          this.$prompt('', '提示', {
            message: h('p', null, [
              h('span', null, '请输入 '),
              h('i', { style: 'color: red' }, '我确认发送'),
              h('i', null, '后，点击确认进行发送')
            ]),
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^我确认发送{0,}$/,
            inputErrorMessage: '输入内容不正确'
          }).then(() => {
            this.buttonLoading = true;
            this.sendVisable = false;
            this.$ajax({
              prompt: true,
              url: '/caseList/manualSendMsg',
              data: this.sendReqBody
            }).then(() => {
              this.buttonLoading = false;
            }).catch(() => {
              this.sendVisable = true;
              this.buttonLoading = false;
            });
          });
        });
      });
    },
    // 更新案件状态
    updateCaseStatus() {
      this.$confirm('确认批量更新案件状态', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/caseList/updateCaseStatus',
          data: this.caseStatusReqBody
        }).then(() => {
          this.caseStatusVisable = false;
        });
      });
    },
    // 更新作业方案
    updatePlan() {
      this.$confirm('确认批量更新作业方案', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/caseList/updatePlan',
          data: this.updatePlanReqBody
        }).then(() => {
          this.updatePlanVisable = false;
        });
      });
    },
    // 更新作业状态
    updateUrge(type) {
      const typeMessage = type === -1 ? '暂停' : '继续';
      console.warn(typeMessage);
      this.$ajax({
        url: '/caseList/urgeCount',
        data: this.caseSearchReq
      }).then((res) => {
        const initCase = res.data.initCase;
        const pauseCase = res.data.pauseCase;
        const continueCase = res.data.continueCase;
        const complateCase = res.data.complateCase;
        let message = '<html>';
        message += `未作业案件:${initCase}条<br/>`;
        message += `作业暂停案件:${pauseCase}条<br/>`;
        message += `作业中案件:${continueCase}条<br/>`;
        message += `作业完成案件:${complateCase}条<br/>`;
        message += '</html>';
        this.$confirm(message, `您确认${typeMessage}作业该案件?包含:`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.urgeStatusReqBody.type = type;
          this.$ajax({
            prompt: true,
            url: '/caseList/updateUrge',
            data: this.urgeStatusReqBody
          });
        });
      });
    },
    // 作业状态点击（校验是否是同一家公司）
    updateStrategyClick() {
      this.$ajax({
        url: '/caseList/companyStrategy',
        data: this.caseSearchReq
      }).then((res) => {
        if (res.data.companyCount === 1) {
          this.strategyGroupRes = res.data.groups;
          this.updateStrategyVisible = true;
        }
      });
    },
    // 更新策略组
    updateStrategy() {
      this.$confirm('您确认更新案件策略组', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/caseList/updateStrategy',
          data: this.updateStrategyReqBody
        }).then(() => {
          this.updateStrategyVisible = false;
        });
      });
    },
    // 更新标签
    updateLabel() {
      this.$confirm('您确认更新案件标签', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/caseList/updateLabel',
          data: this.updateLabelReqBody
        }).then(() => {
          this.updateLabelVisable = false;
        });
      });
    },
    async downloadData(filePath) {
      if (!filePath) {
        this.$message({
          type: 'error',
          message: '下载失败，请刷新重试'
        });
        return;
      }
      await this.$downloadSplit({
        url: '/caseList/download',
        path: filePath
      }).then(() => {
        this.$ajax({
          url: 'caseList/delete',
          method: 'DELETE',
          params: { 'filePath': filePath }
        });
      });
    },
    exportExcelSplit() {
      if (this.caseRes.totalRecords > 10000) {
        this.$message({
          type: 'error',
          message: '案件个数大于10000不能导出'
        });
        return;
      }
      this.$message({
        type: 'success',
        message: '文件导出中，请稍后。。。'
      });
      // 导出前设置排序字段为 rc.id，确保数据唯一性排序
      this.caseSearchReq.order = 'rc.id';
      this.$ajax({
        url: '/caseList/exportExcelSplit',
        method: 'POST',
        data: this.caseSearchReq
      }).then((res) => {
        this.downloadData(res.data);
      });
    },
    exportExcel() {
      if (this.caseRes.totalRecords > 10000) {
        this.$message({
          type: 'error',
          message: '案件个数大于10000不能导出'
        });
        return;
      }
      this.caseSearchReq.Authorization = localStorage.getItem('authorization');
      const fileUrl = `${this.$url}/caseList/exportExcel`;
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(this.caseSearchReq).forEach((key) => {
        const value = this.caseSearchReq[key];
        if (value != null) {
          const input = document.createElement('input');
          input.setAttribute('name', key);
          input.setAttribute('value', value);
          input.style.display = 'none';
          form.appendChild(input);
        }
      });
      form.submit();
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        document.body.removeChild(form);
      }, 1000);
    },
    // 录音文件下载
    exportRecordFileDownload() {
      this.caseSearchReq.Authorization = localStorage.getItem('authorization');
      const fileUrl = `${this.$url}/caseList/exportRecordFileDownload`;
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(this.caseSearchReq).forEach((key) => {
        const value = this.caseSearchReq[key];
        if (value != null) {
          const input = document.createElement('input');
          input.setAttribute('name', key);
          input.setAttribute('value', value);
          input.style.display = 'none';
          form.appendChild(input);
        }
      });
      form.submit();
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        document.body.removeChild(form);
      }, 1000);
    },
    // 录音翻译下载
    exportRecordTranslationDownload() {
      this.caseSearchReq.Authorization = localStorage.getItem('authorization');
      const fileUrl = `${this.$url}/caseList/exportRecordTranslationDownload`;
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(this.caseSearchReq).forEach((key) => {
        const value = this.caseSearchReq[key];
        if (value != null) {
          const input = document.createElement('input');
          input.setAttribute('name', key);
          input.setAttribute('value', value);
          input.style.display = 'none';
          form.appendChild(input);
        }
      });
      form.submit();
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        document.body.removeChild(form);
      }, 1000);
    },
    exportEmail() {
      this.$confirm('您确认要导出案件信息到邮箱?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 导出前设置排序字段为 rc.id，确保数据唯一性排序
        this.caseSearchReq.order = 'rc.id';
        this.$ajax({
          url: '/caseList/exportEmail',
          data: this.caseSearchReq
        }).then((res) => {
          console.warn(res);
          this.$message({
            message: `案件列表导出成功,稍候将发送到您的邮箱，请注意查收（${res.data}）`,
            type: 'success'
          });
        });
      });
    },
    // 案件状态下拉框
    caseStatusSearch(val) {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/caseStatus',
        params: { 'val': val }
      }).then((res) => {
        this.caseStatusList = res.data;
      });
    },

    visable(command) {
      if (command === 'caseStatus') {
        this.caseStatusSearch('');
        this.caseStatusVisable = true;
      }
      if (command === 'updatePlan') {
        this.updatePlanVisable = true;
      }
      if (command === 'pauseUrge') {
        this.updateUrge(-1);
      }
      if (command === 'continueUrge') {
        this.updateUrge(1);
      }
      if (command === 'updateStrategy') {
        this.updateStrategyClick();
      }
      if (command === 'updateLabel') {
        this.updateLabelVisable = true;
      }
      if (command === 'exportExcel') {
        this.$confirm('您确认要导出Excel?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportExcelSplit();
        });
      }
      if (command === 'exportRecordFileDownload') {
        this.$confirm('您确认要下载录音文件?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportRecordFileDownload();
        });
      }
      if (command === 'exportRecordTranslationDownload') {
        this.$confirm('您确认要下载录音翻译?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportRecordTranslationDownload();
        });
      }
      // 导出至日蚀
      if (command === 'exportProperty') {
        console.warn('导出至日蚀');
        this.$ajax({
          url: '/caseList/checkUser',
          method: 'get'
        }).then((res) => {
          if (res.data === 'jump') {
            this.$confirm('您尚未绑定资易通账号，是否前往公司信息立即绑定？', '导出至资易通系统', {
              confirmButtonText: '跳转至公司信息',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({ path: '/main/company/robotCompanyManage' });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消发送'
              });
            });
          } else {
            this.zytServerToken = res.data;
            this.exportCaseToProperty();
          }
        });
      }
      if (command === 'exportEmail') {
        this.exportEmail();
      }
      // 更新还款及金额
      if (command === 'importForm') {
        this.fileList = [];
        this.importFormVisable = true;
      }
      // 添加联系人
      if (command === 'importContactForm') {
        this.fileList = [];
        this.importContactFormVisable = true;
      }
      // 导入为新公司案件
      if (command === 'importNewCase') {
        this.importNewCaseBody.companyId = null;
        this.importNewCaseBody.groupId = null;
        this.$ajax({
          url: '/company/getChildGroupByPid'
        }).then((res) => {
          if (res.data) {
            this.strategyGroupList = res.data;
            this.importNewCaseBody.companyId = this.strategyGroupList[0].companyId;
            this.importNewCaseFormVisable = true;
          } else {
            this.$message({
              type: 'error',
              message: '当前公司未配置子公司'
            });
          }
        });
      }
    },
    // 展示案件导出数量
    exportCaseToProperty() {
      this.count = this.caseRes.totalPages;
      this.exportCaseToPropertyModel = true;
    },
    // 导出至日蚀系统提交
    exportCaseToZYT() {
      const queryData = this.caseSearchReq;
      const search = {};
      const caseSearch = queryData;
      const zyt = this.zyt;
      search.caseSearch = caseSearch;
      search.commissionRateA = zyt.commissionRateA;
      search.platformRate = zyt.platformRate;
      search.startTime = zyt.exportStartTime;
      search.endTime = zyt.exportEndTime;
      search.exportNewBatch = zyt.exportNewBatch;
      search.zytServerToken = this.zytServerToken;
      if (new Date(zyt.exportStartTime).getTime() >= new Date(zyt.exportEndTime).getTime()) {
        this.$message({
          type: 'error',
          message: '起委时间不能大于或等于结委时间'
        });
        return;
      }
      this.$ajax({
        url: '/caseList/getExportCaseList',
        data: search
      }).then((res) => {
        const err = JSON.parse(res.data);
        if (err.success) {
          this.exportCaseToPropertyModel = false;
          this.$message({
            type: 'success',
            message: `${err.msg}该批次号为: ${err.data.batchId}`
          });
        } else {
          this.$message({
            type: 'error',
            message: err.msg
          });
        }
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // --------
    // 导入更新功能
    getFile(event) {
      this.file = event.target.files[0];
    },
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    handlePreview(file) {
      console.warn(file);
    },
    beforeRemove() {
      this.fileList = [];
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    // 更新还款及金额
    importUpdateUploadData() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this.$ajax({
        prompt: true,
        url: '/robotCaseImport/importCaseToUpdate',
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        this.importFormVisable = false;
      });
    },
    // 添加联系人
    addContactInfo() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this.$ajax({
        prompt: true,
        url: '/robotCaseImport/importContactToAdd',
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        this.importContactFormVisable = false;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 发送模版下拉框
    getSendChannel() {
      this.$ajax({
        url: '/externalServicesConf/getSendChannel',
        params: {
          'sendType': this.sendReqBody.sendReq.sendType
        }
      }).then((res) => {
        this.channelList = res.data;
        this.sendReqBody.sendReq.channel = 'all';
      });
    },
    getChangeType() {
      this.templateList();
      this.getSendChannel();
    },
    strategyGroupChange() {
      this.templateList();
    },
    importNewCaseButton() {
      if (!this.importNewCaseBody.groupId) {
        this.$message({
          type: 'error',
          message: '请选择策略组'
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        url: '/caseList/urgeCount',
        data: this.caseSearchReq
      }).then((res) => {
        const initCase = res.data.initCase;
        const pauseCase = res.data.pauseCase;
        const continueCase = res.data.continueCase;
        const complateCase = res.data.complateCase;
        const pCaseCount = res.data.pCaseCount;
        const subCaseCount = res.data.subCaseCount;
        let message = '<html>';
        message += `未作业案件: ${initCase}条<br/>`;
        message += `<span style="color: red;">作业暂停案件: ${pauseCase}条</span><br/>`;
        message += `作业中案件: ${continueCase}条<br/>`;
        message += `<span style="color: red;">作业完成案件: ${complateCase}条</span><br/>`;
        message += `主案数量: ${pCaseCount}条</span><br/>`;
        message += `子案数量: ${subCaseCount}条</span><br/>`;
        message += '</html>';
        this.$confirm(message, '确认对该批案件复制到新公司吗', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$ajax({
            prompt: true,
            url: '/caseList/importNewCase',
            data: this.importNewCaseBody
          }).then(() => {
            loading.close();
            this.importNewCaseFormVisable = false;
          }).catch(() => {
            loading.close();
            this.importNewCaseFormVisable = true;
          });
        }).catch(() => {
          loading.close();
        });
      });
    },
    // 录音转文本
    wavToText() {
      this.$ajax({
        method: 'POST',
        url: '/caseList/caseWavToText',
        data: this.caseSearchReq
      }).then(() => {
        this.$message.success('操作成功');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/case/listOperate.vue